import { render, staticRenderFns } from "./cp_top_bar.vue?vue&type=template&id=bc4b97b4&scoped=true"
import script from "./cp_top_bar.vue?vue&type=script&lang=js"
export * from "./cp_top_bar.vue?vue&type=script&lang=js"
import style0 from "./cp_top_bar.vue?vue&type=style&index=0&id=bc4b97b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4b97b4",
  null
  
)

export default component.exports